import { getUserInfo, logout } from "utils/interface";
import { CQ } from "utils/commonQuest";

// 用户信息相关
export const userInfo = {
  state: {
    user: {
      // 用户名称
      name: "",
      // 允许提交消息
      submitNotice: false
    }
  },
  reducers: {
    // 更新用户信息
    updateUser(state, data: any) {
      return {
        ...state,
        user: data
      };
    }
  },
  effects: {
    // 获取用户信息
    async getUser(payload: any, rootState: any) {
      // 等待异步调用的结果
      const data = await CQ(getUserInfo());
      if (typeof data === "string") {
        this.updateUser({
          name: data
        });
      } else {
        this.updateUser({
          name: data.fullname,
          id: data.id,
          submitNotice: data.isChat
        });
      }
    },
    // 登出系统
    async logout(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      // 等待异步调用的结果
      logout().then((res: any) => {
        const { code, url } = res;
        // status 200 表示接口调用成功
        if (code === "0000") {
          // 返回数据
          callback(url);
        } else {
          console.log("请求失败1");
          console.warn(res);
          // return {
          //   error: true,
          //   res
          // };
        }
      });
    }
  }
};
